<div class="container">
  <nav aria-label="breadcrumb" style="--bs-breadcrumb-divider: '>';" aria-label="breadcrumb">
    <ol class="breadcrumb border-0 p-0">
      <li class="breadcrumb-item">
        <a class=" text-decoration-none" routerLink="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
               class="bi bi-house-door-fill" viewBox="0 0 16 16">
            <path
              d="M6.5 14.5v-3.505c0-.245.25-.495.5-.495h2c.25 0 .5.25.5.5v3.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.146-.354L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.354 1.146a.5.5 0 0 0-.708 0l-6 6A.5.5 0 0 0 1.5 7.5v7a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5"/>
          </svg>
          <span jhiTranslate="global.menu.home">news</span>
        </a>
      </li>
      <li class="breadcrumb-item active text-secondary" aria-current="page">
        3.10.2018
      </li>
    </ol>
  </nav>
  <div class="row">
    <div class="col">
      <h3 class="mb-0 text-primary">Sexcare als Gastreferentin Clubanlass Kiwanis-Luzern-Pilatus 1. Oktober 2018 Hotel
        Wilden Mann</h3>
      <div class="mb-1 text-body-secondary">3.10.2018</div>
      <p>
        Ich bedanke mich recht herzlich beim Club Präsidenten Daniel Meyer wie allen Anwesenden für den gelungenen
        Abend, Last but not least dem Gastgeber Arno Affolter und seiner Entourage
        <a href="https://www.wilden-mann.ch/hotel" target="_blank">
          Wilden Mann
        </a>
        für den äusserst freundlichen Empfang und aufmerksame Bedienung.
        In Begleitung von Vroni (Rollstuhlfahrerin, Gast der Dienstleistung) und Laszlo (Sexualbegleiter) hatte ich als
        Geschäftsführerin die Gelegenheit, Damen und Kiwanisfreunde mit einem
        <a class=" text-primary" routerLink="/link to Fach und Podiumsgespraeche">
          Referat
        </a> fundiert und offen in die Thematik
        Sexualität und Behinderung mitzunehmen.
        Einen speziellen Dank möchte ich Vroni aussprechen: liebe Vroni, es ist alles andere als selbstverständlich so
        offen über eigene Sexualität, Erlebnisse, Enttäuschungen aber auch ganz wunderschöne Momente zu sprechen. Deine
        natürliche Art, uns ZuhörerInnen die schönste
        Nebensache der Welt mit Deinen Augen und Gespür näher zu bringen ist eine wundervolle Bereicherung, herzlichen
        Dank!
      </p>
      <p>
        Isabelle Kölbl
      </p>


    </div>

    <div class="col-auto h d-lg-block">
      <img src="/../../../content/blog/blog5_1.jpg" alt="sexcare bild" width="250">
    </div>
  </div>
</div>
